import { BlockConfig } from '@skyeng/libs/shared/blocks/core';
import { BlockGroupComponent } from './component/group/group';
import { ValueProvider, Type, ExistingProvider, forwardRef } from '@angular/core';
import { CONTENT_COMPONENTS, CONTENT_PREFORMATTERS } from './const';
import { BlocksContentPreformatter } from './interface';

export function getBlockConfig<T extends object>(blockGroupComponent?: BlockGroupComponent<T>): BlockConfig<T> {
  if (blockGroupComponent) {
    return blockGroupComponent.getConfig();
  }

  return new BlockConfig<T>();
}

export function getBlockContentGroupId<T extends object>(
  blockGroupComponent?: BlockGroupComponent<T>,
): string | undefined {
  return blockGroupComponent ? blockGroupComponent.getContentGroupId() : undefined;
}

export function registerContentComponents(
  contentComponents: Type<unknown>[],
  preformatters: BlocksContentPreformatter[] = [],
): ValueProvider[] {
  return [
    { provide: CONTENT_COMPONENTS, useValue: contentComponents, multi: true },
    { provide: CONTENT_PREFORMATTERS, useValue: preformatters, multi: true },
  ];
}

export abstract class ColoredBackgroundContainer {}

export function makeColoredBackgroundContainerProvider(
  coloredBackgroundContainerComponent: () => Type<ColoredBackgroundContainer>,
): ExistingProvider {
  return { provide: ColoredBackgroundContainer, useExisting: forwardRef(coloredBackgroundContainerComponent) };
}

export function getDomPath(element: Element, path: string[] = []): string[] {
  const parent = element.parentElement;

  if (parent === null) {
    // eslint-disable-next-line functional/immutable-data
    return path.reverse();
  }

  return getDomPath(parent, [...path, element.tagName]);
}
